(function() {
  /**
   * Debounces a function. Only calls it once it has been quiet for <delay> milliseconds
   * @param callback Function to call
   * @param delay How long the debounced function needs to go without being called, before trigger the callback
   */
  function debounce(callback, delay = 250) {
    let timeout = undefined;
    return function() {
      const context = this;
      const args = arguments;
      clearTimeout(timeout);

      timeout = setTimeout(() => {
        timeout = undefined;
        callback.apply(context, args);
      }, delay);
    };
  }

  class MegaMenu {
    constructor(menu, id, show_callback = () => {}) {
      this.SHOW_HIDE_TIMEOUT = 200;

      this.menu = menu;
      this.id = id;
      this.anchor = document.querySelector('.js-mega-menu-anchor');
      this.show_timeout = null;
      this.hide_timeout = null;
      this.show_callback = show_callback;

      document.querySelectorAll(`.js-mega-menu-opener[data-mega-menu-id="${this.id}"]`).forEach((opener) => {
        opener.addEventListener('mouseover', () => {
          this.maybeShow();
        });
        opener.addEventListener('mouseout', () => {
          this.maybeHide();
        });
      });

      this.menu.addEventListener('mouseover', () => {
        this.maybeShow();
      });
      this.menu.addEventListener('mouseout', () => {
        this.maybeHide();
      });

      window.addEventListener('resize', debounce(() => {
        this.positionMenu();
      }));
    }

    maybeShow() {
      if (this.hide_timeout) {
        clearTimeout(this.hide_timeout);
        this.hide_timeout = null;
      }

      if (this.show_timeout) {
        return;
      }

      if (this.menu.classList.contains('is-active')) {
        return;
      }

      this.show_timeout = setTimeout(() => {
        this.show();
      }, this.SHOW_HIDE_TIMEOUT);
    }

    show() {
      this.positionMenu();
      this.menu.classList.add('is-active');
      this.show_callback();
    }

    maybeHide() {
      if (this.show_timeout) {
        clearTimeout(this.show_timeout);
        this.show_timeout = null;
      }

      if (this.hide_timeout) {
        return;
      }

      if (!this.menu.classList.contains('is-active')) {
        return;
      }

      this.hide_timeout = setTimeout(() => {
        this.hide();
      }, this.SHOW_HIDE_TIMEOUT);
    }

    hide() {
      this.menu.classList.remove('is-active');
    }

    positionMenu() {
      let offset = 0;
      const admin_bar = document.querySelector('#wpadminbar');
      if (admin_bar) {
        offset = admin_bar.getBoundingClientRect().height;
      }

      const anchor_rect = this.anchor.getBoundingClientRect();
      this.menu.style.top = `${anchor_rect.bottom - offset}px`;
    }
  }

  function main() {
    const mega_menus = document.querySelectorAll('.js-mega-menu-2');
    const mega_menu_instances = [];
    function hideOthers(menu_id_being_opened) {
      mega_menu_instances.forEach((menu) => {
        if (menu.id !== menu_id_being_opened) {
          menu.hide();
        }
      });
    }

    for (let i = 0; i < mega_menus.length; i++) {
      // Set a callback to hide all the other menus as another opens up
      const id = mega_menus[i].dataset.id;
      const menu = new MegaMenu(mega_menus[i], id, () => hideOthers(id));
      mega_menu_instances.push(menu);
    }
  }

  if (document.readyState === 'interactive' || document.readyState === 'complete') {
    main();
  } else {
    document.addEventListener('DOMContentLoaded', main);
  }
})();
